<div class="header-logo-container" [class.hidden]="!showLogo()">
    @if (isHomePage()) {
        <h1 class="sr-only" i18n="@@hermes-seo-head-title-homepage">The official Hermes online store - Homepage</h1>
    }
    <h-logo [class.white]="shouldShowWhiteText()" (click)="onLogoClick()"></h-logo>
</div>

<div class="header-bar-icons">
    <div class="menu">
        <nav
            [attr.role]="'navigation'"
            [attr.data-testid]="'header-menu-navigation'"
            i18n-aria-label="@@hermes.accessibility.navigation_menu"
            aria-label="Navigation menu">
            <button
                [attr.aria-haspopup]="'dialog'"
                [attr.aria-controls]="'tray-nav-shop'"
                [id]="isUnderMenuBreakpoint ? 'collection-button' : 'burger-menu'"
                class="button button-icon button-not-black"
                (click)="sendTopNavigationEvent('MenuBurger')"
                [hTrayOpener]="'menu-tray'"
                [trayPosition]="'left'"
                [categoryInstitutional]="true"
                [trayOverlay]="true"
                aria-label="Menu"
                i18n-aria-label="@@block--hermes-commerce--nav.shop"
                [trayTitle]="'hermes-categories-tree.shop'">
                <h-svg-icon [name]="'bars'" class="icon" [class.white]="shouldShowWhiteText()"></h-svg-icon>
                <span class="icon-label paragraph-small" aria-hidden="true" i18n="@@block--hermes-commerce--nav.shop"
                    >Menu</span
                >
            </button>
        </nav>
    </div>

    <div class="search-bar" [attr.data-testid]="'header-search-bar'">
        <h-header-search-bar (searchExpanded)="onSearchExpanded($event)"></h-header-search-bar>
    </div>

    <nav
        class="account-and-cart"
        aria-label="account and cart"
        i18n-aria-label="@@hermes.accessibility.navigation_menu_account_and_cart"
        role="navigation">
        <ul class="header-bar-icons">
            <li class="account">
                @if ((isLoggedIn$ | async) === true) {
                    <a
                        href="{{ baseHref + accountUrl }}"
                        class="button button-icon button-not-black"
                        [class.white]="shouldShowWhiteText()"
                        [class.inactive-ff]="!isHeaderFullTransparentFF()"
                        id="account-link"
                        (click)="goToPage($event, accountUrl)">
                        <h-svg-icon
                            [name]="'person-with-dot'"
                            class="icon-logged"
                            [class.white]="shouldShowWhiteText()"></h-svg-icon>
                        <span hSrOnlyNoSnippet i18n="@@block--hermes-commerce--nav.user-account">Account</span>
                        <span hSrOnlyNoSnippet>, </span>
                        <span hSrOnlyNoSnippet i18n="@@hermes.customer_account.connected">Connected</span>
                        <span
                            class="icon-label paragraph-small"
                            aria-hidden="true"
                            i18n="@@block--hermes-commerce--nav.user-account"
                            >Account</span
                        >
                    </a>
                } @else {
                    <a
                        href="{{ baseHref + loginUrl }}"
                        class="button button-icon button-not-black"
                        [class.white]="shouldShowWhiteText()"
                        [class.inactive-ff]="!isHeaderFullTransparentFF()"
                        id="account-link"
                        (click)="goToPage($event, loginUrl)">
                        <h-svg-icon
                            [name]="'person'"
                            class="icon-logged"
                            [class.white]="shouldShowWhiteText()"></h-svg-icon>
                        <span hSrOnlyNoSnippet i18n="@@block--hermes-commerce--nav.user-account">Account</span>
                        <span hSrOnlyNoSnippet>, </span>
                        <span hSrOnlyNoSnippet i18n="@@hermes.customer_account.disconnected">Offline</span>
                        <span
                            class="icon-label paragraph-small"
                            aria-hidden="true"
                            i18n="@@block--hermes-commerce--nav.user-account"
                            >Account</span
                        >
                    </a>
                }
            </li>
            <li class="cart">
                <button
                    [attr.data-testid]="'header-cart-button'"
                    (click)="goToCartAndSendEvent('ShoppingCart')"
                    (keypress.enter)="goToCart()"
                    class="button button-icon button-not-black"
                    [class.white]="shouldShowWhiteText()"
                    [class.inactive-ff]="!isHeaderFullTransparentFF()"
                    id="open-cart">
                    <div class="cart-icon">
                        @if (totalItems$ | async) {
                            <h-svg-icon
                                [name]="'filled-cart'"
                                class="icon-cart"
                                [class.white]="shouldShowWhiteText()"></h-svg-icon>
                        } @else {
                            <h-svg-icon
                                [name]="'cart'"
                                class="icon-cart"
                                [class.white]="shouldShowWhiteText()"></h-svg-icon>
                        }
                        @if (totalItems$ | async) {
                            <div class="items-counter" aria-hidden="true" [class.white]="shouldShowWhiteText()"
                                ><span>{{ totalItems$ | async }}</span></div
                            >
                        }
                    </div>
                    <span
                        class="icon-label paragraph-small"
                        aria-hidden="true"
                        i18n="@@block--hermes-commerce--nav.cart"
                        >Cart</span
                    >
                    <span hSrOnlyNoSnippet i18n="@@block--hermes-commerce--nav.cart">Cart</span>
                    <span hSrOnlyNoSnippet>, </span>
                    @if (totalItems$ | async) {
                        <span hSrOnlyNoSnippet>{{ totalItems$ | async }}</span>
                    }
                    <span hSrOnlyNoSnippet id="accessibility-header-cart-count">{{
                        basketFacade.cart$ | async | cartLabel
                    }}</span>
                    <ng-template #cart
                        ><h-svg-icon
                            [name]="'cart'"
                            class="icon-cart"
                            [class.white]="shouldShowWhiteText()"></h-svg-icon
                    ></ng-template>
                </button>
            </li>
        </ul>
    </nav>
</div>
